import { TrackingPrefixes } from '../../tracking-prefixes';

export const ManualTemplateTypeTrackingIds = {
  MANUAL_MESSAGE: 'manual',
  MANUAL_MESSAGE_PET: 'manual-pet',
  MANUAL_FORMS_MESSAGE: 'forms',
  MANUAL_REVIEW_REQUEST: 'review-request',
  MANUAL_REVIEW_REQUEST_PET: 'review-request-pet',
  MANUAL_PAYMENT_REQUEST: 'payment-request',
  MANUAL_APPOINTMENT_REMINDER: 'appointment-reminder',
  MANUAL_APPOINTMENT_REMINDER_PET: 'appointment-reminder-pet',
  MANUAL_SCHEDULE_QUICK_FILL: 'schedule-quick-fill',
} as Record<string, string>;

export function getManualTemplateTrackingId(slug: string, isDefault: boolean): string | undefined {
  if (slug in ManualTemplateTypeTrackingIds) {
    const type = isDefault ? `default-${ManualTemplateTypeTrackingIds[slug]}` : ManualTemplateTypeTrackingIds[slug];
    return `${TrackingPrefixes.TemplateSelector}-select-${type}-template`;
  }
  return undefined;
}
